import type { Reducer } from '@reduxjs/toolkit'

type ReducerInjector = (key: string, reducer: Reducer) => void

let injectReducer: ReducerInjector | null = null

export function configureReducerInjector(injector: ReducerInjector): void {
  injectReducer = injector
}

export function injectFeatureReducer(key: string, reducer: Reducer): void {
  if (!injectReducer) throw new Error('Reducer injector chưa sẵn sàng.')
  injectReducer(key, reducer)
}
